export { default as Img200 } from './processed/200/My-Dinner-With-Herve.jpg';
export { default as Img400 } from './processed/400/My-Dinner-With-Herve.jpg';
export { default as Imgthumb } from './processed/thumb/My-Dinner-With-Herve.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/My-Dinner-With-Herve.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/My-Dinner-With-Herve.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      14,
      147,
      171
    ],
    "_population": 78,
    "_hsl": [
      0.5254777070063694,
      0.8486486486486485,
      0.3627450980392157
    ]
  },
  "LightVibrant": {
    "_rgb": [
      221,
      194,
      157
    ],
    "_population": 22,
    "_hsl": [
      0.09635416666666663,
      0.4848484848484849,
      0.7411764705882353
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      120,
      35,
      24
    ],
    "_population": 48,
    "_hsl": [
      0.019097222222222227,
      0.6666666666666666,
      0.2823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      93,
      155,
      170
    ],
    "_population": 290,
    "_hsl": [
      0.5324675324675324,
      0.31174089068825905,
      0.5156862745098039
    ]
  },
  "LightMuted": {
    "_rgb": [
      199,
      187,
      180
    ],
    "_population": 186,
    "_hsl": [
      0.06140350877192965,
      0.1450381679389312,
      0.7431372549019608
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      58,
      52
    ],
    "_population": 1402,
    "_hsl": [
      0.025641025641025637,
      0.27272727272727276,
      0.2803921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/My-Dinner-With-Herve.js